module.exports = "<ul class=\"tools__list\">\n    <li class=\"tools__item tools__item_add-user\"\n        [routerLink]=\"['./new']\">\n        Добавить\n    </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/contacts/contacts-tools/contacts-tools.component.html
// module id = 614
// module chunks = 1